import {useState} from 'react';
import NumericInput from 'shared/components/NumericInput';
import RadioInput from 'shared/components/RadioInput';
import NextButton from 'shared/components/NextButton';
import {AmortizationSubsteps, QuoteTermsSteps, dateOptions} from 'core/_consts';
import {getMaxLimit, validateNumericInput} from 'core/utils';
import {setAmount} from 'store/quote-terms-service/quoteTermsSlice';
import {selectAmortizationAmount} from 'store/quote-terms-service/quoteTermsSelector';
import {useSelector} from 'react-redux';

const Amount = () => {
  const defaultValues = useSelector(selectAmortizationAmount);
  const [amortizationAmount, setAmortizationAmount] = useState(defaultValues.amortizationAmount);
  const [dateFormat, setDateFormat] = useState(defaultValues.dateFormat);

  return (
    <div className="FormSlide">
      <p className="FormSlide__title mb35">What is the amortization?</p>
      <div className="FormSlide__section">
        <NumericInput
          width="60px"
          decimalScale={0}
          defaultValue={amortizationAmount || ''}
          preventionLimit={getMaxLimit(dateFormat)}
          onValueChange={(values) => setAmortizationAmount(Number(values.value))}
          isValid={validateNumericInput(amortizationAmount, getMaxLimit(dateFormat))}
        />
        <RadioInput
          controlledInputValue={amortizationAmount}
          defaultValue={dateFormat}
          setRadioInputValue={setDateFormat}
          values={Object.values(dateOptions)}
        />
      </div>
      <NextButton
        isDisabled={!validateNumericInput(amortizationAmount, getMaxLimit(dateFormat))}
        slideData={{[AmortizationSubsteps[AmortizationSubsteps.amount]]: {amortizationAmount, dateFormat}}}
        action={setAmount}
        nextSlide={{
          step: QuoteTermsSteps[QuoteTermsSteps.amortization],
          substep: AmortizationSubsteps[AmortizationSubsteps.interestOnlyPeriod],
        }}
      />
    </div>
  );
};

export default Amount;
